import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { store } from './store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "tailwindcss/tailwind.css";
import favicon from './app/assets/favicon.ico';
import { CSP_NONCE } from './app/shared/services/cspNonce';

const ensureFavicon = (iconHref: string) => {
  const existingLink = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  const link = existingLink ?? document.createElement('link');
  link.rel = 'icon';
  link.href = iconHref;
  if (!existingLink) {
    document.head.appendChild(link);
  }
};

ensureFavicon(favicon);

/**
 * MUI styles its components through emotion, which writes them into <style>
 * tags at runtime. The production CSP allows no inline styles (security audit:
 * Weak CSP, no 'unsafe-inline'), so those tags are only applied when they carry
 * the page's nonce. Without it every MUI component renders unstyled: giant
 * dropdown arrows and icons. See app/shared/services/cspNonce.
 */
const emotionCache = createCache({ key: 'css', nonce: CSP_NONCE });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// DISABLED: React.StrictMode causes double renders in development,
// which doubles API calls and overloads the database.
// Re-enable for debugging React issues: wrap <App /> with <React.StrictMode>
root.render(
  <CacheProvider value={emotionCache}>
    <Provider store={store}>
      <App />
    </Provider>
  </CacheProvider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
